var VendorTypeEnum;
(function (VendorTypeEnum) {
    VendorTypeEnum["AccumVendor"] = "accum_vendor";
    VendorTypeEnum["EligibilityVendor"] = "eligibility_vendor";
    VendorTypeEnum["ClaimExtract"] = "claim_extract";
})(VendorTypeEnum || (VendorTypeEnum = {}));
export var vendorTypeOptions = [
    { label: 'Accum Vendor', value: VendorTypeEnum.AccumVendor },
    { label: 'Eligibility Vendor', value: VendorTypeEnum.EligibilityVendor },
    { label: 'Claim Extract', value: VendorTypeEnum.ClaimExtract }
];
var ChangesTypeEnum;
(function (ChangesTypeEnum) {
    ChangesTypeEnum["New"] = "new";
    ChangesTypeEnum["Update"] = "update";
})(ChangesTypeEnum || (ChangesTypeEnum = {}));
export var changesTypeOptions = [
    { label: 'New', value: ChangesTypeEnum.New },
    { label: 'Update', value: ChangesTypeEnum.Update }
];
var SftpEnum;
(function (SftpEnum) {
    SftpEnum["Existing"] = "existing";
    SftpEnum["New"] = "new";
})(SftpEnum || (SftpEnum = {}));
export var sftpOptions = [
    { label: 'Existing', value: SftpEnum.Existing },
    { label: 'New', value: SftpEnum.New }
];
var LayoutTypeEnum;
(function (LayoutTypeEnum) {
    LayoutTypeEnum["_834835"] = "834/835";
    LayoutTypeEnum["RightwayLayout"] = "Rightway layout";
    LayoutTypeEnum["ClientCustomLayout"] = "Client custom layout";
})(LayoutTypeEnum || (LayoutTypeEnum = {}));
export var layoutTypeOptions = [
    { label: '834/835', value: LayoutTypeEnum._834835 },
    { label: 'Rightway layout', value: LayoutTypeEnum.RightwayLayout },
    { label: 'Client custom layout', value: LayoutTypeEnum.ClientCustomLayout }
];
var vendorAttachmentTypeEnum;
(function (vendorAttachmentTypeEnum) {
    vendorAttachmentTypeEnum["Layout"] = "Layout";
    vendorAttachmentTypeEnum["GroupStructure"] = "Group Structure";
    vendorAttachmentTypeEnum["Hierarchy"] = "Hierarchy";
})(vendorAttachmentTypeEnum || (vendorAttachmentTypeEnum = {}));
export var vendorAttachmentTypeOptions = [
    { label: 'Layout', value: vendorAttachmentTypeEnum.Layout },
    { label: 'Group Structure', value: vendorAttachmentTypeEnum.GroupStructure },
    { label: 'Hierarchy', value: vendorAttachmentTypeEnum.Hierarchy }
];
